export default "__VITE_PUBLIC_ASSET__20b86802__"